export default __webpack_public_path__ + "static/media/resizeVideo.342db664.png";